﻿import {RefObject, useEffect} from "react";
import {getHtmlElement} from "./getHtmlElement";

function setScrollbarWidth(element: HTMLElement): void {
	element.style.overflowY = "scroll";
	element.style.scrollbarGutter = "stable";
	element.ownerDocument.documentElement.style.setProperty("--scrollbar-width", `${element.offsetWidth - element.clientWidth}px`);
	element.style.overflowY = "";
	element.style.scrollbarGutter = "";
}

export function useSetScrollbarWidth(mainRef: RefObject<HTMLElement | null> | HTMLElement | string): void {
	useEffect(() => {
		const element = getHtmlElement(mainRef);
		if (!element) return;

		const observer = new ResizeObserver(() => {
			setScrollbarWidth(element);
		});

		observer.observe(element);
		setScrollbarWidth(element);

		return () => observer.disconnect();

	}, [mainRef]);
}
